import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface TablePageSkeletonProps {
  rows?: number;
  columns?: number;
  showAvatar?: boolean;
  className?: string;
}

export default function TablePageSkeleton({ rows = 6, columns = 5, showAvatar = false, className }: TablePageSkeletonProps) {
  return (
    <Card className={className} role="status" aria-label="Loading table">
      <div className="grid gap-4 border-b border-dash-border px-5 py-3" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
        {Array.from({ length: columns }, (_, index) => <Skeleton key={index} className="h-3 w-16" />)}
      </div>
      {Array.from({ length: rows }, (_, row) => (
        <div key={row} className="grid items-center gap-4 border-b border-dash-border px-5 py-4 last:border-0" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
          {Array.from({ length: columns }, (_, column) => (
            <div key={column} className="flex items-center gap-3">
              {showAvatar && column === 0 && <Skeleton className="size-8 shrink-0 rounded-full" />}
              <Skeleton className={column === columns - 1 ? "ml-auto h-7 w-8" : "h-4 w-full max-w-28"} />
            </div>
          ))}
        </div>
      ))}
      <span className="sr-only">Loading rows…</span>
    </Card>
  );
}
